export default "__VITE_ASSET__DcFc_DP4__"